import React from 'react';
interface PlanPriceProps {
  /** Regular monthly price, e.g. "$39.99". */
  price: string;
  /** e.g. "/mo" or " + $24.99/seat" */
  priceSuffix: string;
}

/**
 * Founding Member promo pricing: the offer leads, the regular price is shown
 * struck through, and the Month-3 rate is stated plainly so the plan never
 * reads as permanently $0.
 */
export function PlanPrice({
  price,
  priceSuffix
}: PlanPriceProps) {
  const regular = `${price}${priceSuffix}`;
  return <div data-id="element-573" data-mp="3h3oly2rljovp">
      <p className="font-serif text-3xl text-purple-800 leading-tight" data-id="element-574" data-mp="3c30mqtt7s1qe">
        2 months free
      </p>
      <p className="mt-2 flex flex-wrap items-baseline gap-x-2.5 gap-y-1" data-id="element-575" data-mp="3q2a5o18t19y2">
        <s className="text-lg text-charcoal/45 decoration-charcoal/45" data-id="element-576" data-mp="3q05qgn5ggoih">
          <span className="sr-only" data-id="element-577" data-mp="3l1vw2erk1rxx">Regular price </span>
          {regular}
        </s>
        <span className="text-sm font-semibold text-charcoal" data-id="element-578" data-mp="15azsdnio1l28">$0 for months 1–2</span>
      </p>
      <p className="mt-4 border-t border-purple-200 pt-3 text-sm text-charcoal/70 leading-relaxed" data-id="element-579" data-mp="10cesjp7bt3eb">
        From Month 3: <strong className="font-semibold text-charcoal" data-id="element-580" data-mp="1u8l147wpb8cq">{regular}</strong>, locked in while
        your membership is active.
      </p>
    </div>;
}